"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TimelineEmailContainerAsync;

var _AsyncComponent = _interopRequireDefault(require("customer-data-ui-utilities/component/AsyncComponent"));

var _react = _interopRequireDefault(require("react"));

var _AsyncComponentErrorHandler = _interopRequireDefault(require("crm_ui/utils/AsyncComponentErrorHandler"));

var _TimelineCardSkeleton = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineCardSkeleton"));

var _TimelineCardError = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineCardError"));

var _ErrorBoundary = _interopRequireDefault(require("customer-data-objects-ui-components/ErrorBoundary"));

function requirement(done) {
  import(
  /* webpackChunkName: "timeline-components-events-email-TimelineEmailContainerAsync" */
  './TimelineEmailContainer').then(function (mod) {
    return mod.default;
  }).then(done, (0, _AsyncComponentErrorHandler.default)('timeline'));
}

function TimelineEmailContainerAsync(props) {
  return _react.default.createElement(_ErrorBoundary.default, {
    boundaryName: "TimelineEmailContainer_TimelineCardError",
    ErrorComponent: _TimelineCardError.default
  }, _react.default.createElement(_AsyncComponent.default, {
    props: props,
    loadingContent: _react.default.createElement(_TimelineCardSkeleton.default, {
      loadingMessage: "profileContentTimeline.loadingEvent.email"
    }),
    requirement: requirement
  }));
}

module.exports = exports.default;